// DOC: https://vuex.vuejs.org/en/mutations.html

import _ from 'lodash';

import {
    getBaskets,
    getBasketsPrivate,
    getTotalWeightByPeople,
    getTotalWeightRounded,
    getAmounts,
} from '../calculations';

export default {
    setMode: (state, mode) => {
        state.mode = mode;
    },
    setOrderable: (state, orderable) => {
        state.orderable = orderable;
    },
    setProductGroups: (state, products) => {
        state.orderable.product_groups = products;
    },
    setPostalCode: (state, payload) => {
        state.postalCode = payload.zip;
        localStorage.setItem('postalCode', payload.zip);
        state.order.invoice_address.zip = payload.zip;
        state.order.invoice_address.city = payload.city;
        state.order.delivery_address.zip = payload.zip;
        state.order.delivery_address.city = payload.city;
    },
    setValidPostalCode: (state, payload) => {
        state.isValidPostalCode = payload;
    },
    setInitialState: (state) => {
        const { orderable } = state;
        const defaultSubscriptionType = state.orderable.product_groups.map((i) => {
            const items = i.products.filter(p => (state.mode === 'private' && p.available_for_private) || (state.mode === 'business' && p.available_for_company));
            if (items.length) {
                return i;
            }
        }).filter(p => p)[0]; // first subscription type
        state.subscriptionType = defaultSubscriptionType.id;
        if (defaultSubscriptionType.appetites.length) {
            state.appetite = defaultSubscriptionType.appetites[1].name; // second appetite "Öpfelchasper"
        }
        state.intervals.monday = orderable.intervals[0].id; // weekly
        state.intervals.wednesday = orderable.intervals[0].id; // weekly
    },
    updateActiveSubscriptionType: (state, id) => {
        state.subscriptionType = id;
        const subscriptionType = state.orderable.product_groups.find(
            s => s.id === state.subscriptionType,
        );
        state.appetite = subscriptionType.appetites[1].name;
    },
    updatePeople: (state, people) => {
        state.people = people;
    },
    updateAppetite: (state, appetite) => {
        state.appetite = appetite;
    },
    updateEarlyDelivery: (state) => {
        state.earlyInvoice = !state.earlyInvoice;
    },
    toggleEditModalVisible: (state) => {
        state.editModalVisible = !state.editModalVisible;
    },
    toggleOrderExtraModalVisible: (state) => {
        state.orderExtraModalVisible = !state.orderExtraModalVisible;
    },
    togglePriceSummaryModalVisible: (state) => {
        state.priceSummaryModalVisible = !state.priceSummaryModalVisible;
    },
    togglePriceSummaryOverviewModalVisible: (state) => {
        state.priceSummaryOverviewModalVisible = !state.priceSummaryOverviewModalVisible;
    },
    toggleInfoModalVisible: (state, content) => {
        state.infoBoxModalVisible = !state.infoBoxModalVisible;
        state.infoBoxModalContent = content;
    },
    toggleQuoteModalVisible: (state) => {
        state.quoteModalVisible = !state.quoteModalVisible;
    },
    toggleLoadingModalVisible: (state) => {
        state.loadingModalVisible = !state.loadingModalVisible;
    },
    setLoadingModalMessage: (state, message) => {
        state.loadingModalMessage = message;
    },
    toggleTestBasketModalVisible: (state) => {
        state.testBasketModalVisible = !state.testBasketModalVisible;
    },
    updatePrivateDeliveryDay: (state, day) => {
        if (state.privateDeliveryDay !== day && !state.order.attention_by.length) {
            state.basketExtra.monday = [];
            state.basketExtra.wednesday = [];
        }
        if (day === 'monday') {
            state.basketExtra.wednesday = [];
        } else {
            state.basketExtra.monday = [];
        }
        state.privateDeliveryDay = day;
    },
    updateIntervals: (state, intervals) => {
        // if (intervals.monday === 2 && state.basketExtra.monday.length) {
        //     state.basketExtra.monday.map((p) => {
        //         p.interval = 2;
        //     });
        // }
        // if (intervals.wednesday === 2 && state.basketExtra.wednesday.length) {
        //     state.basketExtra.wednesday.map((p) => {
        //         p.interval = 2;
        //     });
        // }

        state.intervals = intervals;

        return state;
    },
    updateIntervalsPrivate: (state, { intervals, privateDeliveryDay }) => {
        const allIntervals = _.cloneDeep(state.intervals);
        allIntervals[privateDeliveryDay] = intervals;
        state.intervals = allIntervals;
        return state;
    },
    updateBaskets: (state, baskets) => {
        state.baskets = baskets;
        return state;
    },
    updateBasketsPrivate: (state, { baskets, privateDeliveryDay }) => {
        const allBaskets = {
            monday: [],
            wednesday: [],
        };
        allBaskets[privateDeliveryDay] = baskets;
        state.baskets = allBaskets;
        return state;
    },
    saveEdit(state) {
        state.editModalVisible = false;
    },
    calculateBaskets(state, { mode }) {
        const subscriptionType = state.orderable.product_groups.find(
            s => s.id === state.subscriptionType,
        );
        const { appetites, variants } = subscriptionType;
        const totalWeight = getTotalWeightRounded(
            getTotalWeightByPeople(appetites, state.appetite, state.people),
        );
        const deliveryBaskets = getBaskets(totalWeight, variants);

        const { monday, wednesday } = getAmounts(totalWeight, deliveryBaskets, subscriptionType, state.baskets, mode);
        let firstDay = 'monday';
        let secondDay = 'wednesday';

        if (subscriptionType.products[0].preferred_delivery_day && subscriptionType.products[0].preferred_delivery_day === 3) {
            firstDay = 'wednesday';
            secondDay = 'monday';
        }

        let newBaskets = {};

        newBaskets[firstDay] = getBaskets(monday, variants);
        newBaskets[secondDay] = getBaskets(wednesday, variants);

        if (!state.order.attention_by.length) {
            if ((state.baskets.monday.length && !newBaskets.monday.length) || (state.baskets.wednesday.length && !newBaskets.wednesday.length)) {
                state.basketExtra.monday = [];
                state.basketExtra.wednesday = [];
            }
        }

        state.baskets = newBaskets;
    },
    calculateBasketsPrivate(state) {
        const subscriptionType = state.orderable.product_groups.find(
            s => s.id === state.subscriptionType,
        );
        const orderableBaskets = subscriptionType.variants;
        const { people, privateDeliveryDay } = state;
        const baskets = {
            monday: [],
            wednesday: [],
        };
        baskets[privateDeliveryDay] = getBasketsPrivate(people, orderableBaskets);

        state.baskets = baskets;
    },
    calculateBasketsPrivateByPeople(state) {
        const subscriptionType = state.orderable.product_groups.find(
            s => s.id === state.subscriptionType,
        );
        const orderableBaskets = subscriptionType.variants;
        const { people, privateDeliveryDay } = state;
        const baskets = {
            monday: [],
            wednesday: [],
        };
        baskets[privateDeliveryDay] = getBasketsPrivate(people, orderableBaskets);

        state.basketPeople = baskets;
        state.baskets = baskets;
    },
    updateAmounts(state, { amount, day }) {
        const { baskets } = state;
        const subscriptionType = state.orderable.product_groups.find(
            s => s.id === state.subscriptionType,
        );
        const orderableBaskets = subscriptionType.variants;
        baskets[day] = getBaskets(amount, orderableBaskets);

        state.baskets = baskets;
    },
    updateSameInvoiceAddress: (state) => {
        state.sameInvoiceAddress = !state.sameInvoiceAddress;
    },
    updateDeliveryAddress(state, deliveryAddress) {
        state.order.user.invoice_by_post = !!deliveryAddress.invoice_by_post;
        state.order.delivery_address = deliveryAddress;
    },
    updateAttentionBy: (state, attentionBy) => {
        state.order.attention_by = attentionBy;
    },
    updateComment: (state, comment) => {
        state.order.comment = comment;
    },
    updateInvoiceAddress(state, { invoiceAddress, deliveryAddress }) {
        state.order.invoice_address = invoiceAddress;
        // copy values from invoice address if delivery address is the same than invoice address
        if (state.sameInvoiceAddress) {
            state.order.invoice_address.company = deliveryAddress.company;
            state.order.invoice_address.firstname = deliveryAddress.firstname;
            state.order.invoice_address.lastname = deliveryAddress.lastname;
            state.order.invoice_address.additional_billing = deliveryAddress.additional_billing;
            state.order.invoice_address.additional_shipping = deliveryAddress.additional_shipping;
            state.order.invoice_address.street = deliveryAddress.street;
            state.order.invoice_address.zip = deliveryAddress.zip;
            state.order.invoice_address.city = deliveryAddress.city;
            state.order.invoice_address.email_contact = deliveryAddress.email_contact;
            state.order.invoice_address.phone = deliveryAddress.phone;
            state.order.invoice_address.mobile = deliveryAddress.mobile;
        }
    },
    updateBasketsSubscriptionType(state) {
        const subscriptionType = state.orderable.product_groups.find(
            s => s.id === state.subscriptionType,
        );
        // change the price of all baskets in store
        const baskets = _.cloneDeep(state.baskets);
        const updatePrice = (b) => {
            const basket = _.cloneDeep(b);
            const orderableBasket = subscriptionType.variants.find(o => o.kg === basket.kg);
            basket.id = orderableBasket.id;
            basket.price = orderableBasket.price;
            return basket;
        };
        baskets.monday = baskets.monday.map(updatePrice);
        baskets.wednesday = baskets.wednesday.map(updatePrice);
        state.baskets = baskets;
    },
    prepareOrder(state) {
        // fill order object with baskets
        // TODO
        state.order.subscriptions = [];
        const baskets = {
            monday: _.groupBy(state.baskets.monday, 'id'),
            wednesday: _.groupBy(state.baskets.wednesday, 'id'),
        };

        Object.keys(baskets.monday).forEach((basketId) => {
            const basket = baskets.monday[basketId];
            const SUBSCRIPTION = {
                product_id: parseInt(basketId, 10),
                quantity: basket.length,
                early_delivery: state.earlyInvoice,
                interval: state.intervals.monday,
                day: 1,
                next_delivery: state.orderable.firstDeliveryDay,
            };
            state.order.subscriptions.push(SUBSCRIPTION);
        });
        Object.keys(baskets.wednesday).forEach((basketId) => {
            const basket = baskets.wednesday[basketId];
            const SUBSCRIPTION = {
                product_id: parseInt(basketId, 10),
                quantity: basket.length,
                early_delivery: state.earlyInvoice,
                interval: state.intervals.wednesday,
                day: 3,
                next_delivery: state.orderable.firstDeliveryDay,
            };
            state.order.subscriptions.push(SUBSCRIPTION);
        });

        const basketExtra = {
            monday: _.groupBy(state.basketExtra.monday, 'id'),
            wednesday: _.groupBy(state.basketExtra.wednesday, 'id'),
        };

        Object.keys(basketExtra.monday).forEach((basketId) => {
            const basket = basketExtra.monday[basketId];
            const SUBSCRIPTION = {
                product_id: parseInt(basketId, 10),
                quantity: basket.length,
                early_delivery: state.earlyInvoice,
                interval: basket[0].interval,
                day: 1,
                next_delivery: state.orderable.firstDeliveryDay,
            };
            state.order.subscriptions.push(SUBSCRIPTION);
        });

        Object.keys(basketExtra.wednesday).forEach((basketId) => {
            const basket = basketExtra.wednesday[basketId];
            const SUBSCRIPTION = {
                product_id: parseInt(basketId, 10),
                quantity: basket.length,
                early_delivery: state.earlyInvoice,
                interval: basket[0].interval,
                day: 3,
                next_delivery: state.orderable.firstDeliveryDay,
            };
            state.order.subscriptions.push(SUBSCRIPTION);
        });
        delete state.order.invoice_address.invoice_by_post;
    },
    setExtra(state, payload) {
        state.selectedExtra = payload;
    },
    updateBasketExtra(state, payload) {
        state.basketExtra = payload;
    },
    updateBasketExtraBasedOnBasket(state) {
        if (!state.baskets.monday.length && state.basketExtra.monday.length) {
            state.basketExtra.monday = [];
        }
        if (!state.baskets.wednesday.length && state.basketExtra.wednesday.length) {
            state.basketExtra.wednesday = [];
        }
    },
    updateSubscription(state, payload) {
        state.order.subscriptions = payload;
    },
    updateExtra(state, payload) {
        state.orderable.extras = payload;
    },
    setFirstDeliveryDay(state, payload) {
        state.orderable.firstDeliveryDay = payload;
    },
    setDeliveryFee(state, payload) {
        state.orderable.deliveryFee = payload;
    },
};



// WEBPACK FOOTER //
// ./static/js/Order/store/mutations.js